<template>
  <div id="LoginPage">
    <b-container fluid class="d-flex vh-100 justify-content-center align-items-center">
      <b-row class="w-100 justify-content-center">
        <b-col class="px-10 py-10 box-shadow-primary login-wrapper col-10 col-md-4">
          <b-col class="text-center logo-wrapper">
            <img :src="logo" alt="" srcset="" class="logo" /><br>
          </b-col>
          <p class="mt-1 mb-7 text-center" style="color: #00264B;">
            <b>ระบบบริหารจัดตารางฝึกอบรมออนไลน์</b>
          </p>

          <b-form-group id="field-email" label-for="emailLogin" :state="stateEmail">
            <b-form-input id="emailLogin" type="email" placeholder="example@email.com" v-model="emailLogin"
              :state="stateEmail" trim @keydown.enter.prevent="goLogin"></b-form-input>
          </b-form-group>
          <b-form-group id="field-password" label-for="passwordLogin" :state="statePassword">
            <b-form-input id="passwordLogin" type="password" minlength="8" placeholder="รหัสผ่าน"
              v-model="passwordLogin" :state="statePassword" @keydown.enter.prevent="goLogin" trim></b-form-input>
          </b-form-group>
          <b-row class="my-7"> 
            <b-col xl="6" lg="6" md="6" sm="6" cols="12" class="">
              <router-link to="/forgetpassword" class="mx-3">ลืมรหัสผ่าน ?</router-link>
            </b-col>
          </b-row>
          <b-button @click="goLogin" id="btnLogin" class="btnmain btn-block my-7 rounded-lg">
            เข้าสู่ระบบ
          </b-button>
          <div class="my-7 text-center">
            ผู้ใช้งานใหม่? <strong><a href="/register">สมัครสมาชิก</a> </strong>
          </div>


          <!-- <span @click="goLoginThaiID"
            class="d-flex align-items-center justify-content-center px-3 py-2 border rounded-lg"
            style="cursor: pointer; user-select: none; gap: 8px;">
            <img src="../../public/images/ThaID2-768x767.png" alt="ThaiD" style="width: 24px; height: 24px;" />
            <span style="color: #00264B; font-weight: 500;">
              เข้าสู่ระบบด้วย ThaiD
            </span>
          </span> -->

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import logo from "./../../public/logo.png";
import Swal from "sweetalert2";
export default {
  name: "loginPage",
  data() {
    return {
      passwordLogin: "",
      emailLogin: "",
      isLoading: false,
      logo: logo,
    };
  },
  props: {
    msg: String,
  },
  computed: {
    statePassword() {
      if (this.passwordLogin.length != 0) {
        return true;
      } else {
        return false;
      }
    },
    stateEmail() {
      if (this.emailLogin.length != 0) {
        return true;
      } else {
        return false;
      }
    },
    invalidFeedbackEmail() {
      if (this.emailLogin.length >= 0) {
        return "โปรดกรอกข้อมูล";
      }
      return "โปรดกรอกข้อมูล";
    },
    invalidFeedbackPassword() {
      if (this.passwordLogin.length >= 0) {
        return "โปรดกรอกข้อมูล";
      }
      return "โปรดกรอกข้อมูล";
    },
  },
  methods: {
    showPassword: function () {
      var passwordInput = document.getElementById("passwordLogin");
      if (passwordInput.type == "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    },
    goLogin() {
      const path = `/`;
      let data = {
        email: this.emailLogin,
        password: this.passwordLogin,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Auth/login", data)
        .then((response) => {
          this.isLoading = false;
          if (response.code == 200) {
            Swal.fire({
              title: "สำเร็จ!",
              confirmButtonText: `ตกลง`,
              icon: "success",
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.$router.push(path);
              }
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          Swal.fire(
            "ผิดพลาด!",
            "ไม่สามารถเข้าสู่ระบบได้ โปรดตรวจสอบอีเมล/รหัสผ่าน",
            "error"
          );
        });
    },

    goLoginThaiID() {
      this.isLoading = true;

      this.$store.dispatch("Auth/loginThainId")
        .then((data) => {
          this.isLoading = false;

          if (data.redirect_url) {
            window.location.href = data.redirect_url;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    }
  },
};
</script>
<style lang="scss" scoped>
#LoginPage {
  height: 100%;
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

.vue-tempalte {
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
  justify-content: center;

  form {
    min-width: 40%;
  }
}

.vertical-center {
  width: 100%;
  height: 100%;
}

.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}

.vertical-center {
  display: flex;
  text-align: left;
  justify-content: center;
  flex-direction: column;
}

.inner-block {
  width: 450px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all 0.3s;
}

.vertical-center .form-control:focus {
  border-color: #2554ff;
  box-shadow: none;
}

.vertical-center h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}

label {
  font-weight: 500;
}

.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7a7a7a;
  margin: 0;
}

.forgot-password a {
  color: #2554ff;
}

.social-icons {
  text-align: center;
  font-family: "Open Sans";
  font-weight: 300;
  font-size: 1.5em;
  color: #222222;
}

.social-icons ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.social-icons ul li {
  display: inline-block;
  zoom: 1;
  width: 65px;
  vertical-align: middle;
  border: 1px solid #e3e8f9;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  background: #f4f6ff;
}

.social-icons ul li a {
  display: block;
  font-size: 1.4em;
  margin: 0 5px;
  text-decoration: none;
}

.social-icons ul li a i {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.social-icons ul li a:focus i,
.social-icons ul li a:active i {
  transition: none;
  color: #222222;
}

.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  height: 77px;
  object-fit: contain;
}

.login-wrapper {
  border-radius: 15px;
  margin-top: -50px;
}

a {
  color: #333 !important;
}
</style>
